export default ".hide-strip {\n  fill: transparent !important;\n}";